export default "__VITE_ASSET__Di1aHWZ2__"